import { type AxiosError } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  MailingSubscriptionControllerApiFactory,
  type MailingSubscriptionRequestV1,
} from '@redteclab/api/clients/bully'

import { useBullyApi } from '../../base-api-communication'
import { type BackendApiResponseError } from '../../base-errors'
import { useGlobalConfigContext } from '../../global-config'

const getNewsletterSubscribeRequestMutationKey = (): string => {
  return 'useNewsletterSubscribeRequestMutation'
}

export const useApiSwrNewsletterSubscribeRequestMutation =
  (): SWRMutationResponse<
    void,
    AxiosError<BackendApiResponseError>,
    string,
    MailingSubscriptionRequestV1
  > => {
    const { tenantAndEnv } = useGlobalConfigContext()

    const client = useBullyApi(MailingSubscriptionControllerApiFactory)

    const fetcher = async (
      swrKey: string,
      data: {
        arg: MailingSubscriptionRequestV1
      },
    ): Promise<void> => {
      const response =
        await client.mailingSubscriptionV1TenantSubscriptionsPost({
          MailingSubscriptionRequestV1: data.arg,
          tenant: tenantAndEnv,
        })

      return response.data
    }

    return useSWRMutation(getNewsletterSubscribeRequestMutationKey(), fetcher)
  }
